import styled from 'styled-components';

export const List = styled.div`
    flex-grow: 1;
`;

export const AddLabel = styled.span`
    ${(props) => props.theme.typography.Paragraph};
`;

export const StepButtons = styled.div`
    display: flex;
    margin-top: 24px;

    > *:not(:only-child) {
        &:first-child {
            margin-right: 8px;
            min-width: 120px;
        }
    }
`;
